var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.settings.module_comments)?_c('div',{staticClass:"o-flex -alignCenter u-colorDarkMediumEmphasis",attrs:{"data-cy":"CommentCount"}},[_c('SvgIcon',{class:{
      's-negativeMarginLeft': !_vm.noOffset,
    },attrs:{"type":"comment_outline","data-cy":"CommentCount__icon","large":_vm.small,"medium":_vm.tiny}}),_c('span',{staticClass:"u-srOnly"},[_vm._v(_vm._s(_vm.$t('comments.comments'))+" ")]),_c('span',{staticClass:"t-fontWeightMedium",class:{
      't-caption1': _vm.small || _vm.tiny,
      'u-marginLeft1': _vm.small || _vm.tiny,
    }},[_vm._v(" "+_vm._s(_vm.count)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }